/**
 * Quality Analysis Service
 * 
 * Service for managing quality analysis sections and agents
 */

import { apiHelpers } from './api';

class QualityService {
  /**
   * Get all quality analysis sections
   */
  async getSections() {
    try {
      const response = await apiHelpers.get('/quality/sections');
      return response.data;
    } catch (error) {
      console.error('Error fetching quality sections:', error);
      throw error;
    }
  }

  /**
   * Get quality agents, optionally filtered by section
   */
  async getAgents(sectionId = null) {
    try {
      const url = sectionId ? `/quality/agents?section_id=${sectionId}` : '/quality/agents';
      const response = await apiHelpers.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching quality agents:', error);
      throw error;
    }
  }

  /**
   * Get quality sections with their associated agents
   */
  async getSectionsWithAgents() {
    try {
      const response = await apiHelpers.get('/quality/sections-with-agents');
      return response.data;
    } catch (error) {
      console.error('Error fetching sections with agents:', error);
      throw error;
    }
  }

  /**
   * Execute a specific quality agent
   */
  async executeAgent(agentId, projectId, context = null) {
    try {
      const response = await apiHelpers.post(`/quality/agents/${agentId}/execute/${projectId}`, {
        context
      });
      return response.data;
    } catch (error) {
      console.error(`Error executing agent ${agentId}:`, error);
      throw error;
    }
  }

  /**
   * Execute all agents in a specific section
   */
  async executeSectionAgents(sectionId, projectId) {
    try {
      const response = await apiHelpers.post(`/quality/sections/${sectionId}/execute/${projectId}`);
      return response.data;
    } catch (error) {
      console.error(`Error executing section ${sectionId} agents:`, error);
      throw error;
    }
  }

  /**
   * Execute all quality agents across all sections
   */
  async executeAllAgents(projectId) {
    try {
      const response = await apiHelpers.post(`/quality/execute-all/${projectId}`);
      return response.data;
    } catch (error) {
      console.error('Error executing all quality agents:', error);
      throw error;
    }
  }

  /**
   * Get details for a specific quality agent
   */
  async getAgentDetails(agentId) {
    try {
      const response = await apiHelpers.get(`/quality/agents/${agentId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching agent ${agentId} details:`, error);
      throw error;
    }
  }
}

const qualityService = new QualityService();
export default qualityService;